<template>
    <div class="pricing-plan-cards-section">
        <div class="col-lg-12 pricing-card-section">
            <div class="pricing-card">
                <validation-observer ref="form" style="width: 80%;">
                    <form style="width: 100%;">

                        <h2>Uw gegevens</h2>
                        <div class="form-group row">
                            <label for="userEmail" class="col-sm-2 col-form-label">Email *</label>
                            <div class="col-sm-10">
                                <validation-provider rule="required|email|unique" :debounce="500" v-slot="{ errors }">
                                    <input required autocomplete="new-password" type="email" class="form-control" id="userEmail" v-model="facility.userEmail" placeholder="E-mail">
                                    <div class="invalid-feedback">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>
                            </div>
                        </div>
                        <!-- <div class="form-group row">
                            <label for="userPassword" class="col-sm-2 col-form-label">Wachtwoord *</label>
                            <div class="col-sm-10">
                                <validation-provider rule="required" v-slot="{ errors }">
                                    <input required autocomplete="new-password" type="password" class="form-control" id="userPassword" v-model="facility.userPassword" placeholder="Wachtwoord">
                                    <div class="invalid-feedback">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>
                            </div>
                        </div> -->
                        <!-- <h2>Stap 2: Voor welk organisatie start u de Family Portal?</h2> -->
                        <div class="form-group row">
                            <label for="name" class="col-sm-2 col-form-label">Voorziening *</label>
                            <div class="col-sm-10">
                                <validation-provider rule="required" v-slot="{ errors }">
                                    <input required type="text" class="form-control" id="facility" v-model="facility.name" placeholder="Naam van uw organisatie">
                                    <div class="invalid-feedback">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-8 offset-sm-2">
                                <button class="btn btn-danger" style="width: 40%; margin-top: 10px; margin-left: 10px;" @click.prevent="$emit('close-form')">Annuleren</button>
                                <button type="submit" class="btn btn-primary" style="width: 50%; margin-top: 10px; margin-left: 10px;" @click.prevent="submitForm()">Start met de Family Portal</button>
                            </div>
                        </div>
                    </form>
                </validation-observer>
                <div v-if="showServerValidationErrors" class="alert alert-danger" role="alert">
                    <ul>
                        <li v-for="error in serverValidationErrors" :key="error">{{ error }}</li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

// Vee Validate
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'

// Axios
import axios from 'axios'

// Add the required rule
extend('required', {
    ...required,
    message: 'Dit veld is verplicht'
})

// Add the email rule
extend('email', {
    ...email,
    message: 'Gelieve een correct e-mail adres op te geven'
})

export default {
    components: {
        ValidationProvider, ValidationObserver
    },

    data() {
        return {
            facility: {
                userName: '',
                userEmail: '',
                userPassword: '',
                name: '',
            },
            serverValidationErrors: [],
            showServerValidationErrors: false
        }
    },

    mounted() {

        extend("unique", {
            validate: this.isEmailUnique,
            message: 'Sorry dit e-mail adres is reeds in gebruik. Contacteer ons indien dat een fout is'
        })

    },

    methods: {

        async isEmailUnique() {
            try {
                const response = await axios.post('/api/check-email-unique', this.facility.userEmail)
                return true
            } catch (err) {
                if(err.response.status == 404) {
                    return false
                }
            }
        },

        submitForm() {
            this.$refs.form.validate().then(success => {
                if(!success) {
                    return
                }
                axios.post(process.env.VUE_APP_SERVER_URL + '/api/create-facility-from-website', this.facility)
                    .then((res) => {
                        console.log(res)
                        // if all went well we can log the user in to the server
                        // for now we just redirect to the server
                        this.$emit('close-form', [ this.facility.userEmail, this.facility.userPassword ])
                    })
                    .catch((err) => {
                        this.serverValidationErrors = err.response.data.errors
                        this.showServerValidationErrors = true
                        console.log('should send me an email with the error')
                    })
            })
        }

    }
}
</script>

<style scoped>

.pricing-card {
    text-align: left !important;
}

.invalid-feedback {
    display: block !important;
}

</style>